import React from 'react';
import { Franchise } from '~/templates/pages';

export const FranchiseContext = React.createContext<Franchise>({} as Franchise);
